/** Gerado por scripts/sync-deploy-revision.mjs — não editar manualmente. */
export const DEPLOY_REVISION = '0cb642dd89f3d2cfbe8929dda65cc1d31ffc76a3' as const;
